'use client';
import { Section } from '@react-stately/collections';
import React__default from 'react';

/**
 * @subcomponent Listbox
 */ const ListboxSection = (props)=>{
    // this never actually gets rendered below, it's only defined for the typescript custom prop hints
    // any prop logic or hooks need to go in the internal option component
    return /*#__PURE__*/ React__default.createElement(Section, props);
};
// the Section component has some functions on it for the react-aria collection behavior.
// This will copy the props over
Object.assign(ListboxSection, Section);
ListboxSection.displayName = 'ListboxSection';

export { ListboxSection };
